import type { PaymentMethod } from '../types/PaymentMethod'

export const mockPaymentMethods: PaymentMethod[] = [
  // 홍길동 결제수단
  { id: 'pm_hong_shinhan', name: '신한 체크카드', type: 'debit_card', ownerId: 'user_001', memo: '주거래 카드', isActive: true },
  { id: 'pm_hong_samsung', name: '삼성 신용카드', type: 'credit_card', ownerId: 'user_001', memo: '온라인 결제용', isActive: true },
  { id: 'pm_hong_kakao', name: '카카오페이', type: 'simple_pay', ownerId: 'user_001', memo: '', isActive: true },
  { id: 'pm_hong_kb', name: 'KB국민 통장', type: 'bank_transfer', ownerId: 'user_001', memo: '급여 계좌', isActive: true },
  { id: 'pm_hong_cash', name: '현금', type: 'cash', ownerId: 'user_001', memo: '', isActive: true },

  // 김영희 결제수단
  { id: 'pm_kim_hyundai', name: '현대 신용카드', type: 'credit_card', ownerId: 'user_002', memo: '포인트 적립', isActive: true },
  { id: 'pm_kim_naver', name: '네이버페이', type: 'simple_pay', ownerId: 'user_002', memo: '', isActive: true },
  { id: 'pm_kim_toss', name: '토스', type: 'simple_pay', ownerId: 'user_002', memo: '', isActive: true },

  // 박철수 결제수단
  { id: 'pm_park_woori', name: '우리 체크카드', type: 'debit_card', ownerId: 'user_003', memo: '', isActive: true },
  { id: 'pm_park_kakao', name: '카카오페이', type: 'simple_pay', ownerId: 'user_003', memo: '', isActive: true },

  /**
   * 공용 결제수단 (ownerId = 'user_shared')
   *
   * @why Mock에 공용 결제수단이 하나도 없어서, 개발 중에는 "공용 카드 →
   * 결제 계좌 소유자가 user_shared가 되는" 경로가 한 번도 실행되지 않았다.
   * 그 사이 일괄 입력의 저장 직전 재검증이 findAll()을 쓰는 바람에
   * 시트에 없는 합성 사용자 '공용'을 참조 불가로 판정해 저장이 막혔고,
   * 실서버에서만 재현되어 발견이 늦어졌다.
   * 실제로 쓰이는 조합은 Mock에도 있어야 개발 중에 걸린다.
   */
  { id: 'pm_shared_card', name: '공용카드', type: 'credit_card', ownerId: 'user_shared', memo: '생활비 공동 결제', isActive: true },
]

// 헬퍼 함수: 사용자별 결제수단 가져오기
export function getPaymentMethodsByUser(userId: string): PaymentMethod[] {
  return mockPaymentMethods.filter(pm => pm.ownerId === userId)
}

// 헬퍼 함수: ID로 결제수단 찾기
export function findPaymentMethodById(id: string): PaymentMethod | undefined {
  return mockPaymentMethods.find(pm => pm.id === id)
}
